import React, {Component} from 'react';
import './CustomerOrderItemTable.css';
import CustomerItemTableHeader from '../CustomerItemTableHeader/CustomerItemTableHeader';
import CustomerItemTableRow from '../CustomerItemTableRow/CustomerItemTableRow';

class CustomerOrderItemTable extends Component{
    constructor(props) {
        super(props);
        /*this.state = {
            orderId: this.props.orderData
        };*/

    }


render() {
    let no=1;
    return (
        <div className="container-fluid">
            <CustomerItemTableHeader/>

            {this.props.orderData.map(orderInfo => {
                return <CustomerItemTableRow orderInfo={orderInfo}  price={this.props.price} no={no++}/>

            })}

        </div>
    )
}
}
export default CustomerOrderItemTable;


// WEBPACK FOOTER //
// ./src/components/Site/Order/SingleOrder/CustomerOrderItemTable/CustomerOrderItemTable.js